import { Tariff } from '@modules/tariff/domain/tariff.types'
import { PowerPeriod, Power } from '@modules/power/domain/power.types'

export type Address = {
  postalCode: number
  address: string
  city: string
  province: string
}

export type TechnicalInfo = {
  tariff: Tariff
  tension: string
}

export type Consumption = {
  period: PowerPeriod
  unit: 'kWh'
  amount: string
}

export type SupplyPointPower = {
  currentByPeriod: Power[]
  optimizedByPeriod: Power[] | []
}

export const ConsumptionStatus = {
  OK: 'ok',
  UPDATING: 'updating',
}
export type SupplyPoint = {
  address: Address
  technicalInfo: TechnicalInfo
  consumptionByPeriod: Consumption[]
  power: SupplyPointPower
  consumptionStatus: string
}
